import request from "../plugins/axios";
//获取详情
export function GetStatisticsLog(params) {
    return request({
        url: '/Statistic/GetStatisticsLog',
        method: 'get',
        params:params
    })
}